import { render, staticRenderFns } from "./ModalCreateGiayBienNhan.vue?vue&type=template&id=77cddc47"
import script from "./ModalCreateGiayBienNhan.vue?vue&type=script&lang=js"
export * from "./ModalCreateGiayBienNhan.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateGiayBienNhan.vue?vue&type=style&index=0&id=77cddc47&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports